import * as interfaces from '#/CoreFrameInterfaces';
/**
* Dies ist eine Mixin für Control, View, Factory etc.
* Wann immer eine Klasse dazu in der Lage ist Knockout - Bindings ausführen, sollte sie einen BindingContext(-Mixin)
* als Property haben oder hier von erben.Bei jedem ko.applyBindings(...) welches potentiell Controls, Factories etc.initialisiert, muss dieser mit übergeben werden.
* Alle so erzeugten Controls, Factories werden dann in diesem BindingContext hinterlegt, um beim Disposing des einbettenden
* Objekts mit - disposed zu werden.
*/
export default class BindingContextMixin implements interfaces.IBindingContextMixin{

    public _registeredDisposables: Array<any> = [];

    public registerDisposable(disposable) {
        if (disposable == null) {
            return;
        }

        this._registeredDisposables.push(disposable);
    }
}